import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'





function PostCreate() {



    const [image, setImage] = useState('')
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [Post_status, setPost_status] = useState('')
    const [token, setToken] = useState('')
    const [userId, setUserId] = useState('')

    const navigate = useNavigate()

     


    const handleImage = (e) => {
       
        setImage(e.target.files[0])

    }



    useEffect(() => {
        setToken(localStorage.getItem('token'))
        setUserId(localStorage.getItem('useuserId'))

    }, [image])


    console.log(image)

    const handlePost = (e) => {

        e.preventDefault()

        const formData = new FormData()

        formData.append('image', image)
        formData.append('title', title)
        formData.append('description', description)
        formData.append('Post_status', Post_status)
        formData.append('token', token)
        formData.append('userID', userId)
        formData.append('like', 0)


        axios.post('https://rahulbloging.onrender.com/postCreate', formData)


            .then((result) => {
                alert("Post Create SuccessFully")
                navigate('/')


            })
            .catch((err) => {
                console.log(err)

                alert(err.response.data.msg)
            })



    }







    return (
        <div>
            <div className="container">

                <form id='d' className='mt-3 bg-info'>

                    <div class="mb-3">
                        <label for="exampleInputEmail1" class="form-label ">Chosse Image</label>
                        <input onChange={handleImage} type="file" class="form-control " id="exampleInputEmail1" aria-describedby="emailHelp" />

                    </div>

                    <div class="mb-3">
                        <label for="exampleInputEmail1" class="form-label">Enter Title</label>
                        <input onChange={(e) => setTitle(e.target.value)} type="text" class="form-control bg-dark text-white" id="exampleInputEmail1" aria-describedby="emailHelp" />

                    </div>
                    <div class="mb-3">
                        <label for="exampleInputPassword1" class="form-label">Enter Description </label>
                        <textarea onChange={(e) => setDescription(e.target.value)} type="text" class="form-control bg-dark text-white" id="exampleInputPassword1" />
                    </div>

                    <div class="mb-3">


                        <select onChange={(e) => setPost_status(e.target.value)} class="form-select form-select-md mt-3 bg-dark text-white  mb-3" aria-label=".form-select-lg example">
                            <option selected>Open this for Post Status</option>
                            <option value="Public">Public</option>
                            <option value="Private">Private</option>
                           
                        </select>







                        {/* <label for="exampleInputPassword1" class="form-label">Enter Post_status</label>
                        <input onChange={(e)=>setPost_status(e.target.value)} type="text" class="form-control" id="exampleInputPassword1" /> */}

                    </div>


                    <button onClick={handlePost} type="submit" class="btn btn-primary m-3">Submit</button>
                </form>

            </div>
        </div>
    )
}

export default PostCreate
